<cb-dialog [dialogHeading]="getTitle()">
    <form class="flex-col" #form="ngForm">
        <cb-select
            label="House Area"
            name="houseArea"
            [(ngModel)]="mappedItem.specGroupId"
            [options]="houseAreas"
            [disabled]="data.lockedSpecGroupId != null || data.locked || !isEditOrAdd()"
            [required]="true"
        ></cb-select>
        <cb-select
            label="Colour Item"
            name="colourItem"
            [(ngModel)]="mappedItem.colourItemId"
            [options]="colourItems"
            [disabled]="data.locked || !isAdd()"
            [required]="true"
        ></cb-select>
        <cb-input
            label="Colour"
            name="colourName"
            [(ngModel)]="mappedItem.name"
            [readonly]="!isEditOrAdd()"
            [required]="false"
        ></cb-input>
        <cb-text-area
            label="Notes"
            name="notes"
            [(ngModel)]="mappedItem.notes"
            [readonly]="!isEditOrAdd()"
            [required]="false"
        ></cb-text-area>
        <div class="flex-row">
            <div class="flex-col" id="imageUploadDropzone" style="max-width: 180px">
                <div class="start-center flex-row flex">
                    @if (imageUrl) {
                        <cb-image-button class="flex" [baseUrl]="imageUrl"></cb-image-button>
                    }
                </div>
                <input
                    type="file"
                    hidden
                    #fileInput
                    (click)="$event.target.value = null"
                    accept=".jpg,.jpeg,.png,.gif,image/jpeg,image/gif,image/png"
                    (change)="uploadFile(form, $event.target.files)"
                />
                <button class="cb-margin-top" mat-raised-button (click)="fileInput.click()">
                    <mat-icon>file_upload</mat-icon>
                    @if (!imageUrl && !mappedItem.specColourItemImageFile) {
                        <span>&nbsp;Upload Image</span>
                    }
                    @if (imageUrl || mappedItem.specColourItemImageFile) {
                        <span>&nbsp;Replace Image</span>
                    }
                </button>
                @if (
                    mappedItem.canRemoveImage && (imageUrl || mappedItem.specColourItemImageFile)
                ) {
                    <button class="cb-margin-top" mat-raised-button (click)="removeImage(form)">
                        <mat-icon>delete</mat-icon>
                        &nbsp;Remove Image
                    </button>
                }
            </div>
        </div>
        <div class="cb-margin-top flex-col flex">
            @if (isAdd()) {
                <cb-nullable-boolean
                    label="Include in Flyer / Create Schedule"
                    name="createScheduleNull"
                    [(ngModel)]="mappedItem.showInClientSpecification"
                    nullLabel="Not Set (Inherit from Colour Item)"
                ></cb-nullable-boolean>
            }
            @if (isEdit()) {
                <cb-checkbox
                    label="Include in Flyer / Create Schedule"
                    name="createSchedule"
                    [(ngModel)]="mappedItem.showInClientSpecification"
                ></cb-checkbox>
            }
        </div>
    </form>
    <div actions>
        <button
            mat-raised-button
            color="primary"
            [disabled]="form.invalid || form.pristine"
            (cbClick)="save()"
            [clickLimit]="1"
        >
            Save
        </button>
        <button mat-raised-button (click)="cancel(form.dirty)">Cancel</button>
    </div>
</cb-dialog>
